import { useDispatch, useSelector } from 'react-redux';
import { cancel } from '../Redux/Rocket/rocketSlice';
import { leave } from '../Redux/Missions/missionSlice';

const Profile = () => {
  const dispatch = useDispatch();
  let allMissions = useSelector((state) => state.missions.missions);
  const localMissions = JSON.parse(localStorage.getItem('missions')) || [];
  if (localMissions.length > 0) {
    allMissions = localMissions;
  }
  const myMissions = allMissions.filter((mission) => mission.join === true);
  let allRockets = useSelector((state) => state.rockets.rockets);
  const localRockets = JSON.parse(localStorage.getItem('rockets')) || [];
  if (localRockets.length > 0) {
    allRockets = localRockets;
  }
  const myRockets = allRockets.filter((rocket) => rocket.reserved === true);
  return (
    <div className="container py-2">
      <div className="row py-5">
        <div className="col-6">
          <h4>My Missions</h4>
          <ul className="list-group ">
            { myMissions.length > 0 ? (myMissions.map((mission) => (
              <li className="list-group-item d-flex justify-content-between align-items-center" key={mission.mission_id}>
                <div>
                  <p className="m-0">{mission.mission_name}</p>
                  <a href={mission.wikipedia} target="_blank" rel="noreferrer">Read more</a>
                </div>
                <button type="button" onClick={() => dispatch(leave(mission.mission_id))} className="d-none d-lg-block d-md-block btn btn-outline-danger">Leave Mission</button>
              </li>
            )))
              : (<li className="list-group-item">No missions</li>)}
          </ul>
        </div>
        <div className="col-6">
          <h4>My Rockets</h4>
          <ul className="list-group">
            { myRockets.length > 0
              ? (myRockets.map((rocket) => (
                <li className="list-group-item d-flex justify-content-between align-items-center" key={rocket.id}>
                  <div>
                    <p className="m-0">{rocket.rocket_name}</p>
                    <a href={rocket.wikipedia} target="_blank" rel="noreferrer">Read more</a>
                  </div>
                  <button type="button" onClick={() => dispatch(cancel(rocket.id))} className="d-none d-lg-block d-md-block btn btn-outline-secondary">Cancel Reservation</button>
                </li>
              )))
              : (
                <li className="list-group-item">
                  No rockets
                </li>
              )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Profile;
